import { Stack } from '@packages/shared';

export type ImageGalleryActionsWrapperProps = {
  children: React.ReactNode;
  isMobile: boolean;
};

export const ImageGalleryActionsWrapper = ({
  children,
  isMobile,
}: ImageGalleryActionsWrapperProps) => (
  <Stack
    direction="column"
    sx={{
      position: 'absolute',
      /** this is the height of the thumbnails with gap - there is no better solution because the Carousel is one element */
      bottom: isMobile ? '72px' : '112px',
      right: 0,
      rowGap: 1,
      mr: 2,
      mb: 2,
    }}
  >
    {children}
  </Stack>
);
